/*
 * @CopyRight    : 广州仰望星空云科技有限公司
 * @Author       : Kyle
 * @Email        : linyukai@xinyu668.com
 * @CreateTime   : 2023-08-15 14:49:03
 * @Description  : 洞察上报配置
 */
// =================================================================
import Report from '@ywxk/report';
import { constConf } from '@GLOBAL/constConf'

const { REPORT_PROJECT_ID, IS_DEBUG, REPORT_INIT_APPLICATION, REPORT_INIT_APPKEY, REPORT_ACT_APPLICATION, REPORT_ACT_APPKEY, REPORT_NAME, REPORT_KEY, REPORT_GATE_WAY, IS_APP_LOCAL } = constConf

const common = {
  isDebug: IS_DEBUG,
  project_id: REPORT_PROJECT_ID,
  key: REPORT_KEY,
  name: REPORT_NAME,
  gateway: REPORT_GATE_WAY,
  isAppLocal: IS_APP_LOCAL
}
// 用户行为上报
const userReport = new Report({
  ...common,
  appKey: REPORT_ACT_APPKEY,
  application: REPORT_ACT_APPLICATION,

})
// 性能上报应用,不区分产品
const initReport = new Report({
  ...common,
  application: REPORT_INIT_APPLICATION,
  appKey: REPORT_INIT_APPKEY,
})
export { userReport, initReport }
